// #TODO: Investigate why is this class an exact duplicate of CalendarScheduleSlotModel
import moment from "moment-timezone";
import { Moment } from "moment-timezone";
import CandidateModel from "../api/models/CandidateModel";
import ScheduleModel from "../api/models/ScheduleModel";
import ScheduleSlotModel, { SlotStates } from "../api/models/ScheduleSlotModel";
import StudentModel from "../api/models/StudentModel";
import ApiDateParser from "../helpers/parsers/apiDateParser";
import CalendarScheduleSlotModel from "./CalendarScheduleSlotModel";
import TutorModel from "../api/models/TutorModel";

export default class CalendarScheduleModelRequest {
  slots: CalendarScheduleSlotModel[];
  constructor(
    schedule: object,
    defaultSlotState: SlotStates = SlotStates.not_started
  ) {
    this.slots = [];
    // TODO the following needs to be refactored, maybe on the backend side also it needs more documentation comments
    Object.values(schedule ?? {}).forEach((daySlots: any) => {
      daySlots.forEach((slot: any) => {
        let startTime = ApiDateParser.parse(slot["start_time"]);
        let endTime = ApiDateParser.parse(slot["end_time"]);

        let slotData: any = {
          startTime: startTime,
          endTime: endTime,
          dayOfWeek: slot["schedule_slot"]["day_of_the_week"],
          id: slot["schedule_slot"]["id"],
          state: defaultSlotState,
        };
        if (!!slot["student"]) {
          slotData["student"] = StudentModel.fromApiResponse(slot.student);
        }
        if (!!slot["tutor"]) {
          slotData["student"] = TutorModel.fromApiResponse(slot.tutor);
        }
        if (!!slot["candidate"]) {
          slotData["student"] = CandidateModel.fromApiResponse(slot.candidate);
        }
        this.slots.push(new CalendarScheduleSlotModel(slotData));
      });
    });
  }

  generateScheduledSlotsMap(): {
    [dayName: string]: CalendarScheduleSlotModel[];
  } {
    let map: any = {};
    this.slots.forEach((slot: CalendarScheduleSlotModel) => {
      if (!!slot.student) {
        if (!map[slot.dayOfWeekName]) map[slot.dayOfWeekName] = [];
        map[slot.dayOfWeekName].push(slot);
      }
    });
    return map;
  }

  get hasScheduledSlots(): boolean {
    return Object.keys(this.generateScheduledSlotsMap()).length > 0;
  }

  countScheduledSlotsOnDay(dayOfWeekName: string): number {
    const scheduledSlots = this.generateScheduledSlotsMap();
    return scheduledSlots[dayOfWeekName]?.length || 0;
  }

  deleteSlot(slotUUID: string): CalendarScheduleSlotModel | undefined {
    let slot: CalendarScheduleSlotModel | undefined = this.findSlot(slotUUID);
    if (!!slot) {
      return this.slots.splice(this.slots.indexOf(slot), 1)[0];
    }
  }

  addSlot(slot: CalendarScheduleSlotModel) {
    this.slots.push(slot);
  }

  findSlot(slotUUID: string): CalendarScheduleSlotModel | undefined {
    return this.slots.find(
      (slot: CalendarScheduleSlotModel) => slot.Uuid === slotUUID
    );
  }
  findSlotByCalendarId(
    calendarId: String
  ): CalendarScheduleSlotModel | undefined {
    return this.slots.find(
      (slot: CalendarScheduleSlotModel) => slot.calendarId === calendarId
    );
  }

  modifySlotsState(slotUUID: string, state: SlotStates) {
    let slot: CalendarScheduleSlotModel | undefined = this.findSlot(slotUUID);
    if (!!slot) {
      slot.state = state;
    }
  }

  modifySlotsStateByCalendarId(calendarId: string, state: SlotStates) {
    let slot: CalendarScheduleSlotModel | undefined =
      this.findSlotByCalendarId(calendarId);
    if (!!slot) {
      slot.state = state;
    }
  }

  modifySlotsStateByDate(referenceDate: Moment) {
    this.slots.forEach((slot) => {
      slot.modifyStateByDate(referenceDate);
    });
  }

  lockDay(dayOfWeekName: string) {
    this.slots.forEach((slot) => {
      if (
        slot.dayOfWeekName === dayOfWeekName &&
        slot.state === SlotStates.reservable
      )
        this.modifySlotsState(slot.Uuid, SlotStates.locked);
    });
  }

  unlockDay(dayOfWeekName: string) {
    this.slots.forEach((slot) => {
      if (
        slot.dayOfWeekName === dayOfWeekName &&
        slot.state === SlotStates.locked
      )
        this.modifySlotsState(slot.Uuid, SlotStates.reservable);
    });
  }
}
